"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceType = exports.Protocol = exports.SimType = void 0;
var SimType;
(function (SimType) {
    SimType["Etisalat"] = "etisalat";
    SimType["Twilio"] = "twilio";
    SimType["STC"] = "stc";
    SimType["Mobily"] = "mobily";
    SimType["Hologram"] = "hologram";
    SimType["SuperSimTwilio"] = "superSimTwilio";
    SimType["Airtel"] = "airtel";
})(SimType = exports.SimType || (exports.SimType = {}));
var Protocol;
(function (Protocol) {
    Protocol["H02"] = "H02";
    Protocol["Teltonica"] = "Teltonica";
    Protocol["Mrs"] = "Mrs";
    Protocol["CarTrack"] = "CarTrack";
    Protocol["GlobalTech"] = "GlobalTech";
    Protocol["ConCox"] = "ConCox";
    Protocol["Howen"] = "Howen";
})(Protocol = exports.Protocol || (exports.Protocol = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["SinotrackST901"] = "SinotrackST901";
    DeviceType["TeltonicaFMM001"] = "TeltonicaFMM001";
    DeviceType["TeltonicaFMB120"] = "TeltonicaFMB120";
    DeviceType["TeltonicaFMC130"] = "TeltonicaFMC130";
    DeviceType["TeltonicaFMM130"] = "TeltonicaFMM130";
    DeviceType["TeltonicaFMB140"] = "TeltonicaFMB140";
    DeviceType["TeltonicaFMM640"] = "TeltonicaFMM640";
    DeviceType["TeltonicaFMB640"] = "TeltonicaFMB640";
    DeviceType["TeltonicaFMB920"] = "TeltonicaFMB920";
    DeviceType["MrsFusionFT10"] = "MrsFusionFT10";
    DeviceType["ConCoxGV40"] = "ConCoxGV40";
    DeviceType["ConCoxJMVL03LTE"] = "ConCoxJMVL03LTE";
    DeviceType["CarTrack"] = "CarTrack";
    DeviceType["GlobalTech"] = "GlobalTech";
    DeviceType["Skid"] = "Skid";
    DeviceType["TeltonicaFMC640"] = "TeltonicaFMC640";
    DeviceType["TeltonicaFMC125"] = "TeltonicaFMC125";
    DeviceType["TeltonicaFMC880"] = "TeltonicaFMC880";
    DeviceType["TeltonicaTAT140"] = "TeltonicaTAT140";
    DeviceType["HowenME4104"] = "HowenME4104";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
//# sourceMappingURL=telematics.js.map